import { useQuery } from '@tanstack/react-query'

import { configurationClient } from '@/api'
import { config } from '@/config'

export const usePricePlans = () => {
  const availablePricePlansQuery = useQuery({
    queryKey: [...configurationClient.QUERY_KEY, 'pricePlans'],
    queryFn: () => configurationClient.getAvailablePricingPlans(),
    staleTime: config.requestsConfig.staleTime.configDictionaries
  })

  return availablePricePlansQuery.data || []
}
